import { useContext } from 'react';

import { Box, Collapsible, Heading, Stack, Text } from "@chakra-ui/react";
import { ChevronRight } from "lucide-react";
import { faqTexts, faqTexts2 } from "../i18n/faq";
import { LanguageContext } from "../contexts/LanguageContext";

const Faq = () => {
  const { language } = useContext(LanguageContext);
  const t = faqTexts[language] || faqTexts["et"];
  const t2 = faqTexts2[language] || faqTexts2["et"];

  return (
    <Box minH="calc(100vh - 4rem)" bg="gray.50" py={{ base: 8, md: 12 }} px={4}>
      <Box maxW="3xl" mx="auto">
        <Box textAlign="center" mb={8}>
          <Text
            fontFamily="space"
            fontSize="xs"
            letterSpacing="0.3em"
            textTransform="uppercase"
            color="gray.500"
            mb={2}
          >
            akordion.ee
          </Text>
          <Heading fontFamily="heading" fontWeight="500" fontSize="3xl" color="gray.900">
            {t2.faq}
          </Heading>
        </Box>

        <Box
          bg="white"
          borderWidth="1px"
          borderColor="gray.200"
          borderRadius="lg"
          boxShadow="sm"
          px={{ base: 4, md: 6 }}
          py={2}
        >
          <Stack gap={0}>
            {Object.keys(t).map((key) => (
              <Collapsible.Root
                key={key}
                defaultOpen={false}
                borderBottomWidth="1px"
                borderColor="gray.100"
                _last={{ borderBottomWidth: 0 }}
              >
                <Collapsible.Trigger
                  paddingY="4"
                  display="flex"
                  gap="3"
                  alignItems="center"
                  width="100%"
                  cursor="pointer"
                  textAlign="left"
                >
                  <Collapsible.Indicator
                    transition="transform 0.2s"
                    _open={{ transform: "rotate(90deg)" }}
                    color="gray.400"
                    flexShrink={0}
                  >
                    <ChevronRight size={18} />
                  </Collapsible.Indicator>
                  <Text fontSize="md" fontWeight="medium" color="gray.900">
                    {t[key].question}
                  </Text>
                </Collapsible.Trigger>

                <Collapsible.Content>
                  <Box
                    ml={{ base: 0, md: 8 }}
                    mb={4}
                    px={4}
                    py={3}
                    bg="gray.50"
                    borderLeftWidth="2px"
                    borderColor="gray.300"
                    borderRadius="sm"
                  >
                    <Text fontSize="sm" color="gray.700" whiteSpace="pre-line">
                      {t[key].answer}
                    </Text>
                  </Box>
                </Collapsible.Content>
              </Collapsible.Root>
            ))}
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default Faq;
